/**
 * Get the label for an element based on its ID (used for accessibility)
 *
 * @param {string | number} id
 * @returns {string}
 */
export const getElementLabel = id => `element-label-${id}`;

export default getElementLabel;
